module.exports = __webpack_public_path__ + "img/dksuccess.d8555675.png";